import { render, staticRenderFns } from "./ChipsList.vue?vue&type=template&id=219a5ef0&"
import script from "./ChipsList.vue?vue&type=script&lang=js&"
export * from "./ChipsList.vue?vue&type=script&lang=js&"
import style0 from "./ChipsList.vue?vue&type=style&index=0&id=219a5ef0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports